<template>
  <div class="container">
    <h2>Find the Right Report for You</h2>
    <p style="text-align: justify;">
    Your <b>personalized Vedic astrology reports</b> are thoughtfully crafted using authentic astrological principles and 
    expert interpretation to provide deep, meaningful insights into your life. Every report focuses on a distinct aspect 
    of your birth chart, <b>offering insights tailored specifically to you</b>.       
    </p>

    <p style="text-align: justify;">
      Based on your interests, these reports may be most relevant:
    </p>

    <ul>
      <li style="padding: 5px;"><b>Want a detailed understanding of planetary influences?</b> → Planetary Positions Report</li>  
      <li style="padding: 5px;"><b>Curious how different life areas are shaped?</b> → House Analysis Report</li>  
      <li style="padding: 5px;"><b>Interested in how Nakshatras impact planetary expression?</b> → Nakshatra Influence Report</li>  
      <li style="padding: 5px;"><b>Looking to navigate upcoming life phases through Dasha cycles?</b> 
        → Mahadasha Analysis Report</li>  
        <li style="padding: 5px;"><b>Want a complete, holistic view of your birth chart?</b> → Get All Reports at <b>25% off</b></li>
    </ul>
    <p style="text-align: justify;">
      Whichever report you choose, <b>you’ll gain valuable insights, deeper self-awareness, and clear guidance</b> to help you make informed choices and align with your true life path.
    </p>

    <div 
      class="report-box"
      @mouseover="hoverIndex = 2"
      @mouseleave="hoverIndex = null"
      :class="{ 'hovered': hoverIndex === 2 }"
    >
    <h3 class="report-title">Planetary Positions Report</h3>
    <p style="text-align: justify;">The Planetary Positions Report analyzes the <b>placement of planets in your birth chart</b>, explaining how they influence various aspects of your life. It covers <b>planetary significations, dignity, rulership, and their combined effects on major life areas</b> with actionable advice to maximize strengths and navigate potential difficulties.</p>

      <a @click="activateMenuItem('purchase-planetary-positions-report')" class="cta-button">Learn More and <br/>Get Your Report</a>      
    </div>

    <div 
      class="report-box"
      @mouseover="hoverIndex = 3"
      @mouseleave="hoverIndex = null"
      :class="{ 'hovered': hoverIndex === 3 }"
    >
    <h3 class="report-title">House Analysis Report</h3>
    <p style="text-align: justify;">The House Analysis Report <b>explores how each house lord influences your life when placed in a different house</b> in your birth chart. It presents this information in a clear and easy-to-understand way, helping you discover how various areas of your life are connected and revealing the patterns, strengths, and themes that naturally shape your life journey.</p>

      <a @click="activateMenuItem('purchase-house-analysis-report')" class="cta-button">Learn More and <br/>Get Your Report</a>            
    </div>

    <div 
      class="report-box"
      @mouseover="hoverIndex = 4"
      @mouseleave="hoverIndex = null"
      :class="{ 'hovered': hoverIndex === 4 }"
    >
    <h3 class="report-title">Nakshatra Influence Report</h3>
    <p style="text-align: justify;">An in-depth <b>exploration of the Nakshatras in which your planets reside</b>, uncovering their influence on the expression of planetary energies in your birth chart.
        Each Nakshatra carries unique characteristics that <b>refine the way a planet manifests its energy in your life</b>.
      </p>

      <a @click="activateMenuItem('purchase-nakshatra-influence-report')" class="cta-button">Learn More and <br/>Get Your Report</a>            
    </div>

    <div 
      class="report-box"
      @mouseover="hoverIndex = 5"
      @mouseleave="hoverIndex = null"
      :class="{ 'hovered': hoverIndex === 5 }"
    >
    <h3 class="report-title">Mahadasha Analysis Report</h3>
    <p style="text-align: justify;">The Mahadasha Analysis Report <b>explains the planetary periods</b> (Mahadashas) you experience in life, unveiling the karmic cycles and its profound influence on your life’s journey and key turning points.
        Each Mahadasha is ruled by a different planet and <b>shapes your key life areas over a specific time frame</b>.
      </p>

      <a @click="activateMenuItem('purchase-mahadasha-analysis-report')" class="cta-button">Learn More and <br/>Get Your Report</a>            
    </div>

    <div 
      class="report-box"
      @mouseover="hoverIndex = 6"
      @mouseleave="hoverIndex = null"
      :class="{ 'hovered': hoverIndex === 6 }"
    >
    <h3 class="report-title">Get All Reports — Now at 25% Off</h3>

      <p style="text-align: justify;">
      For those seeking a complete, in-depth understanding of their birth chart, 
      the <span style="font-weight:600; color:#1b5e20;">Comprehensive Astrology Report</span> brings together 4 individual reports - planetary positions, nakshatra influences, house analysis, and Mahadasha periods -  
      <b>into one integrated experience</b>. This bundled report offers a holistic view of your life themes, strengths, and planetary periods, ensuring 
      no essential layer of your chart is left unexplored.      
      </p>
    
      <p style="text-align: justify;">
        For a limited time, you can access this <b>complete astrological insight at 25% off the original price</b>, 
        making it the most valuable and personalized Vedic astrology guidance available—whether you are new to Vedic astrology or 
        looking for deeper, advanced insights.
      </p>

      <a @click="activateMenuItem('purchase-all-reports')" class="cta-button">Learn More and <br/>Get All Reports</a>            
    </div>
  </div>

  <div class="cta-button-group">
    <button @click="activateMenuItem('chart')" class="cta-btn cta-paid">View Birth Chart</button>
    <button @click="activateMenuItem('home')" class="cta-btn cta-paid">Edit Birth Details</button>
    <!--<button @click="activateMenuItem('free-report')" class="cta-btn cta-free" title="Instant access to your personalized birth chart analysis and insights">Read Your Free Report</button>-->
  </div>

</template>

<script>
export default {
  data() {
    return {
      hoverIndex: null
    };
  },
  mounted() {
    window.scrollTo(0, 0); // Instantly scroll to top when component is mounted
  },  
	methods: {
		activateMenuItem( activeMenuItem ) {
			this.$emit('activeMenuItem', activeMenuItem);
		},
	}
};
</script>

<style scoped>

.report-title {
  color: #087F8C
}

p, ul {
  text-align: left;
}
ul {
  padding-left: 20px;
}

.container {
  max-width: 800px;
  margin: 30px auto;
  padding-right: 25px;
  padding-left: 25px;
  padding-top: 5px;
  padding-bottom: 5px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.report-box {
  background: #EDF6F9;
  padding: 15px;
  margin: 15px 0;
  border-left: 5px solid #2c3e50;
  border-radius: 5px;
  transition: transform 0.2s ease, background-color 0.2s ease;
  text-align: left; /* Left-aligned content */
}
.report-box.hovered {
  transform: scale(1.01);
  background: #bbdefb;
}
h1, h2, h3 {
  color: #2c3e50;
  text-align: left; /* Left-align headings */
}
p {
  line-height: 1.6;
  text-align: left; /* Left-align paragraphs */
}
.cta-button {
  display: inline-block;
  padding: 12px 25px;
  background-color: #087F8C;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  margin: 20px 0;
  font-weight: bold;
  text-align: center;
  width: fit-content;
  cursor: pointer;
}
.cta-button:hover {
  background-color: #218838;
}

/* Ensuring margin consistency across all screen sizes */
@media (max-width: 800px) {
  .container {
    margin: 20px; /* Apply same margin on mobile devices */
    padding: 15px; /* Reduce padding slightly for better spacing */
  }
}

.cta-button-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 20px;
}

.cta-btn {
  padding: 12px 24px;
  font-size: 18px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 200px;
  text-align: center;
}

/* Free Button Style */
.cta-free {
  background-color: #344E41;
  color: #FFF;
  font-weight: bold;
  border: 2px solid transparent;
}

/* Paid Button Style */
.cta-paid {
  background-color: #344E41;
  color: #fff;
  font-weight: bold;
  border: 2px solid transparent;
}

/* Mobile Friendly */
@media screen and (max-width: 480px) {
  .cta-btn {
    min-width: 90%;
    font-size: 18px;
  }
}

</style>
